// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__35igW","footer":"ModalCreateQualiphyProcedure_footer__a8R9f","additionData":"ModalCreateQualiphyProcedure_additionData__mRgCU"};